import type { CustomerProfileDetailsResponseDTO } from '@/types/dto/agent';

// Maps a consent checkbox state to the API consent-decision shape, keeping the
// CONSENT_DECISION.* classification codes in one place (shared by the signup
// and account-settings consent forms).
export const toConsentDecision = ({
  code,
  checked,
}: {
  code?: string;
  checked: boolean;
}) => ({
  code,
  decisionId: checked
    ? 'CONSENT_DECISION.ACCEPTED'
    : 'CONSENT_DECISION.NOT_ACCEPTED',
});

export const getDisplayName = (
  profile?: Pick<
    CustomerProfileDetailsResponseDTO,
    'firstName' | 'lastName' | 'email'
  > | null
) => {
  if (!profile) return;

  const { firstName, lastName, email } = profile;

  if (firstName && lastName) {
    return `${firstName} ${lastName}`;
  }

  if (firstName || lastName) {
    const firstInitial = firstName?.[0] || '';
    const lastInitial = lastName?.[0] || '';
    return `${firstInitial}${lastInitial}`.toUpperCase();
  }

  if (!email) return '';

  const [localPart] = email.split('@');
  const parts = localPart.split(/[._-]/);
  return parts
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toUpperCase();
};
